"use strict";

exports.__esModule = true;
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _react = _interopRequireWildcard(require("react"));

var _Context = _interopRequireDefault(require("./Context"));

var _material = require("@mui/material");

var _Config = require("base-shell/lib/providers/Config");

var _Auth = require("base-shell/lib/providers/Auth");

var _reactIntl = require("react-intl");

var _notistack = require("notistack");

var _SnackMessage = _interopRequireDefault(require("../../../components/SnackMessage/SnackMessage"));

var _messaging = require("firebase/messaging");

var _database = require("firebase/database");

var _app = require("firebase/app");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var isSupported = function isSupported() {
  return 'Notification' in window && 'serviceWorker' in navigator && 'PushManager' in window;
};

var Provider = function Provider(_ref) {
  var children = _ref.children;

  var _useState = (0, _react.useState)(false),
      token = _useState[0],
      setToken = _useState[1];

  var intl = (0, _reactIntl.useIntl)();

  var _useConfig = (0, _Config.useConfig)(),
      appConfig = _useConfig.appConfig;

  var _useAuth = (0, _Auth.useAuth)(),
      _useAuth$auth = _useAuth.auth,
      auth = _useAuth$auth === void 0 ? {} : _useAuth$auth;

  var _ref2 = auth || {},
      uid = _ref2.uid,
      _ref2$notificationsDi = _ref2.notificationsDisabled,
      notificationsDisabled = _ref2$notificationsDi === void 0 ? false : _ref2$notificationsDi;

  var _ref3 = appConfig || {},
      firebaseConfig = _ref3.firebase;

  var _ref4 = firebaseConfig || {},
      _ref4$prod = _ref4.prod,
      prod = _ref4$prod === void 0 ? {} : _ref4$prod,
      _ref4$dev = _ref4.dev,
      dev = _ref4$dev === void 0 ? {} : _ref4$dev;

  var firebase = process.env.NODE_ENV !== 'production' ? dev : prod;

  var _ref5 = firebase || {},
      messagingConfig = _ref5.messaging;

  var _ref6 = messagingConfig || {},
      publicVapidKey = _ref6.publicVapidKey;

  var _useSnackbar = (0, _notistack.useSnackbar)(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar,
      closeSnackbar = _useSnackbar.closeSnackbar;

  var syncToken = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee(token) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!notificationsDisabled) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              setToken(token);
              _context.prev = 3;

              if (!uid) {
                _context.next = 7;
                break;
              }

              _context.next = 7;
              return (0, _database.set)((0, _database.ref)((0, _database.getDatabase)(), "notification_tokens/" + uid + "/" + token), true);

            case 7:
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](3);
              console.warn(_context.t0);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 9]]);
    }));

    return function (_x) {
      return _ref7.apply(this, arguments);
    };
  }(), [uid, notificationsDisabled]);
  var initializeMessaging = (0, _react.useCallback)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
    var messaging, token;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            messaging = (0, _messaging.getMessaging)();
            (0, _messaging.onMessage)(messaging, function (payload) {
              enqueueSnackbar('', {
                content: function content(key) {
                  return /*#__PURE__*/_react.default.createElement(_SnackMessage.default, {
                    payload: payload,
                    id: key
                  });
                }
              });
            });
            _context2.next = 4;
            return (0, _messaging.getToken)(messaging, {
              vapidKey: publicVapidKey
            });

          case 4:
            token = _context2.sent;
            syncToken(token);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), [enqueueSnackbar, publicVapidKey, syncToken]);
  (0, _react.useEffect)(function () {
    if (isSupported() && Notification.permission === 'granted' && !notificationsDisabled) {
      initializeMessaging();
    }
  }, [initializeMessaging, notificationsDisabled]);

  var requestPermission = function requestPermission(_ref9) {
    var _ref9$onDismiss = _ref9.onDismiss,
        onDismiss = _ref9$onDismiss === void 0 ? function () {} : _ref9$onDismiss;

    var action = function action(key) {
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Button, {
        onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
          var permission;
          return _regenerator.default.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (!isSupported()) {
                    _context3.next = 6;
                    break;
                  }

                  closeSnackbar(key);
                  _context3.next = 4;
                  return Notification.requestPermission();

                case 4:
                  permission = _context3.sent;

                  if (permission === 'granted') {
                    initializeMessaging();
                  }

                case 6:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        })),
        style: {
          margin: 8
        } //color="inherit"
        ,
        variant: "contained",
        size: "small"
      }, intl.formatMessage({
        id: 'enable',
        defaultMessage: 'Enable'
      })), /*#__PURE__*/_react.default.createElement(_material.Button, {
        onClick: function onClick() {
          onDismiss && onDismiss();
          closeSnackbar(key);
        },
        size: "small",
        color: "secondary"
      }, intl.formatMessage({
        id: 'no_thanks',
        defaultMessage: 'No, thanks'
      })));
    };

    if (!('Notification' in window)) {
      console.log('This browser does not support desktop notification');
      return;
    }

    if (Notification.permission === 'default') {
      enqueueSnackbar(intl.formatMessage({
        id: 'enable_notifications',
        defaultMessage: 'Enable Notifications?'
      }), {
        variant: 'default',
        persist: true,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'center'
        },
        action: action
      });
    } else if (Notification.permission === 'granted') {
      console.log('Notifications are enabled');
      initializeMessaging();
    }
  };

  return /*#__PURE__*/_react.default.createElement(_Context.default.Provider, {
    value: {
      requestPermission: requestPermission,
      token: token
    }
  }, children);
};

var _default = Provider;
exports.default = _default;
module.exports = exports.default;